import {createContext} from 'react';

const AuthContext = createContext({
  user: {
    role: '',
    name: '',
    warehouseId: '',
    partnerId: ''
  }, // store all the user details
});

export const AuthProvider = AuthContext.Provider;
export const AuthConsumer = AuthContext.Consumer;

export default AuthContext;
